import React, { useCallback, useEffect } from 'react';
import { Container } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react-lite';
import { HeaderBreadcrumbs, Page } from '../../../components';
import { BecomePartnerForm } from '../Form';
import { BecomePartnerValues, Link, QueryParams } from '../../../types';
import { useRequest, useStore } from '../../../hooks';
import { StateWrapper } from '../../../components/common/StateWrapper';
import rules from '../Form/rules';
import { PATH_DASHBOARD } from '../../../app';

const LINKS: Link[] = [
  { name: 'Dashboard', href: PATH_DASHBOARD.root },
  { name: 'Become A Partner', href: PATH_DASHBOARD.becomePartner.list },
  { name: 'Edit' },
];

export const UpdateBecomePartner: React.FC = observer(() => {
  const { id } = useParams<QueryParams>();
  const { push } = useHistory();

  const {
    becomePartner: {
      getBecomePartnerById,
      updateBecomePartner,
      fetchBecomePartnerById,
    },
  } = useStore();

  const message = getBecomePartnerById(id);

  const form = useForm<BecomePartnerValues>({
    defaultValues: {
      contactPersonName: '',
      companyName: '',
      country: '',
      city: '',
      email: '',
      websiteUrl: '',
    },
    resolver: yupResolver(rules),
  });

  const handleUpdate = useCallback(async (values: BecomePartnerValues) => {
    await updateBecomePartner(id, values);
    push(PATH_DASHBOARD.becomePartner.list);
  }, [id]);

  const { isFetching, isError } = useRequest({
    action: fetchBecomePartnerById,
    params: id,
    condition: !message,
  });

  useEffect(() => {
    if (message) {
      form.reset({
        contactPersonName: message.contactPersonName,
        companyName: message.companyName,
        country: message.country,
        city: message.city,
        phoneNumber: message.phoneNumber,
        email: message.email,
        websiteUrl: message.websiteUrl,
      });
    }
  }, [message]);

  return (
    <Page title="Edit Become A Partner Contact">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs heading="Edit Become A Partner Contact" links={LINKS} />
        <FormProvider {...form}>
          <StateWrapper isError={isError} isReady={!!message && !isFetching}>
            <BecomePartnerForm onAction={handleUpdate} />
          </StateWrapper>
        </FormProvider>
      </Container>
    </Page>
  );
});
